import moment from 'moment';
import 'moment/locale/fr';
import { FaArrowRight, FaCheck, FaFileInvoiceDollar, FaRoute, FaXmark } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { IExpense } from '../../../../types';
import { IconWrapper } from '../../../IconWrapper/IconWrapper';
import styles from './Expenses.module.scss';

interface IExpensesProps { expenses: IExpense[]; }

const Expenses = ({ expenses }: IExpensesProps) => {
  const navigate = useNavigate();
  const sortedExpenses = [...expenses].sort(
    (a, b) => new Date(a.start_date ?? a.date).getTime() - new Date(b.start_date ?? b.date).getTime()
  );
  const formatDate = (expense: IExpense) => expense.type === 'trip' && expense.start_date && expense.end_date
    ? `${moment(expense.start_date).format('LL')} - ${moment(expense.end_date).format('LL')}`
    : moment(expense.date).format('LL');

  if (sortedExpenses.length === 0) {
    return (
      <div className={styles.Empty}>
        <div className={styles.EmptyIcon}><IconWrapper icon={FaFileInvoiceDollar} /></div>
        <h2>No expense reports yet</h2>
        <p>Create a report to start tracking your expenses and mileage.</p>
      </div>
    );
  }

  return (
    <div className={styles.Grid}>
      {sortedExpenses.map((expense) => {
        const isTrip = expense.type === 'trip';
        return (
          <button type="button" className={styles.ExpenseCard} key={expense._id} onClick={() => navigate(`/expense/${expense._id}`)}>
            <div className={styles.CardTop}>
              <span className={`${styles.Type} ${isTrip ? styles.Trip : styles.Expense}`}>
                <IconWrapper icon={isTrip ? FaRoute : FaFileInvoiceDollar} /> {isTrip ? 'Trip' : 'Expense'}
              </span>
              <span className={styles.Arrow}><IconWrapper icon={FaArrowRight} /></span>
            </div>
            <h2 className={styles.Name}>{expense.name}</h2>
            <p className={styles.Date}>{formatDate(expense)}</p>
            <div className={styles.Footer}>
              <span className={expense.active ? styles.Active : styles.Inactive}>
                <IconWrapper icon={expense.active ? FaCheck : FaXmark} /> {expense.active ? 'Active' : 'Archived'}
              </span>
              <span>{expense.lines.length} line{expense.lines.length > 1 ? 's' : ''}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default Expenses;
